export default __webpack_public_path__ + "static/media/gif-img.79e2f2e9.webm";